import React, { Fragment } from "react";
import { DataSheet, Observations, LineTitle, Measure } from "../index";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { TYPES_ITEMS } from "../../../../api/constant";
import {
  faPenToSquare,
  faPlus,
  faSearch,
  faWeightScale,
} from "@fortawesome/free-solid-svg-icons";
import { types } from "../../../../reducers/inventory/articleReducer";
import {
  useDispatchArticleForm,
  useArticle,
  useActionsArticle,
} from "../../../../context/inventory/ArticleFormProvider";
import "./createArticle.css";
import Moment from "react-moment";
import { FORMAT_DATE_MOMENT } from "../../../../api/constant";
import Movements from "./tabs/Movements";
import Inventory from "./tabs/Inventory";
import { useNavigate } from "react-router-dom";

const CreateArticle = () => {
  const dispatchArticleForm = useDispatchArticleForm();
  const state = useArticle();
  const actions = useActionsArticle();
  let navigate = useNavigate();
  const {
    description,
    name,
    code,
    id,
    created_at,
    updated_at,
    has_date_made,
    has_date_expired,
    has_lote,
    to_edit,
    documents,
    type,
    lookedItems
  } = state.article;

  const changeInputArticle = (e) => {
    dispatchArticleForm({
      type: types.CHANGE_INPUT_ARTICLE,
      payload: { name: e.target.name, value: e.target.value },
    });
  };
  const getTypeName = (code) => {
    const types = TYPES_ITEMS.filter(t => t.type === code);
    if (types.length !== 0) {
      return types[0].name
    }
    return "Sin tipo"
  };
  return (
    <section className="container-fluid">
      <LineTitle title={"Maestro de artículo"} />


      <section className=" form-create-article">
        <div className="row">
          <div className="id-article-create flex">
            <div className="id-article-create-without-padding">
              <label className="font1 ">ID</label>
              <div disabled className="form-control font2">
                {id}
                &nbsp;
              </div>
            </div>
            <div className="date-article-create">
              <label className="font1 ">Fecha de creación</label>
              <div disabled className="form-control font2">
                &nbsp;
                <Moment format={FORMAT_DATE_MOMENT}>{created_at}</Moment>
              </div>
            </div>
          </div>
          <div className="name-article-create-article">
            <label className="font1 ">Nombre artículo</label>
            {!id && (
              <Fragment>
                <div className="input-to-search">
                  <input
                    name="name"
                    value={name}
                    onChange={(e) => changeInputArticle(e)}
                    type="text"
                    className="form-control"
                  />
                  <FontAwesomeIcon
                    icon={faSearch}
                  />
                </div>

                {lookedItems.length > 0 && (
                  <div className="container-items-looked-for flex-column">
                    {lookedItems.map((pro) => {
                      return (
                        <label
                          onClick={() => navigate(`/inventory/article/${pro.id}`)}
                          key={pro.id}

                        >
                          {pro.name} - {pro.code}
                        </label>
                      );
                    })}
                  </div>
                )}
              </Fragment>
            )
            }

            {id && <input
              disabled={!to_edit}
              onChange={(e) => changeInputArticle(e)}
              value={name}
              type="text"
              name="name"
              className="form-control"
            />}

          </div>
          <div className="measure-type-article">
            <label className="font1 margin-auto">Referencia</label>
            &nbsp;
            {!id && <div className="input-to-search">
              <input
                name="code"
                value={code}
                onChange={(e) => changeInputArticle(e)}
                type="text"
                className="form-control"
              />
              <FontAwesomeIcon
                icon={faSearch}
              />
            </div>}
            {id && <input
              disabled={!to_edit}
              onChange={(e) => changeInputArticle(e)}
              type="text"
              value={code}
              name="code"
              className="form-control"
            />
            }
          </div>
          <div className="measure-type-article">
            <label className="font1 margin-auto">Tipo de medida</label>
            &nbsp;
            <input
              disabled={true}
              type="text"
              value={getTypeName(type)}
              name="code"
              className="form-control"
            />
          </div>
          <div className="flex conatiner-lote-article-create">
            <div className="form-group">
              <input
                type="checkbox"
                disabled={!to_edit}
                checked={has_lote}
                onChange={(e) =>
                  dispatchArticleForm({
                    type: types.CHANGE_INPUT_ARTICLE,
                    payload: {
                      name: "has_lote",
                      value: e.target.checked,
                    },
                  })
                }
              />
              &nbsp;
              <label>Maneja Lotes</label>
            </div>
            {has_lote && (<div><div className="form-group">
              <input
                checked={has_date_expired}
                disabled={!to_edit}
                onChange={(e) =>
                  dispatchArticleForm({
                    type: types.CHANGE_INPUT_ARTICLE,
                    payload: {
                      name: "has_date_expired",
                      value: e.target.checked,
                    },
                  })
                }
                type="checkbox"
              />
              &nbsp;
              <label>Requiere fecha de vencimiento</label>
            </div>
              <div className="form-group">
                <input
                  checked={has_date_made}
                  disabled={!to_edit}
                  onChange={(e) =>
                    dispatchArticleForm({
                      type: types.CHANGE_INPUT_ARTICLE,
                      payload: {
                        name: "has_date_made",
                        value: e.target.checked,
                      },
                    })
                  }
                  type="checkbox"
                />
                &nbsp;
                <label>Requiere fecha de fabricación</label>
              </div></div>)}    
          </div>
          <div className="id-article-create flex">
            {updated_at && (
              <div className="date-article-create">
                <label className="font1 ">Última modificación</label>
                <div disabled className="form-control font2">
                  &nbsp;
                  <Moment format={FORMAT_DATE_MOMENT}>{updated_at}</Moment>
                </div>
              </div>
            )}
          </div>
        </div>
        

        <div
          style={{ marginTop: "12px" }}
          className="flex   col-md-12 col-lg-12"
        >
          <div className="form-group flex col-sm-6 col-md-12  col-md-6 col-lg-6">
            <label className="font1 margin-auto">Descripción</label>
            &nbsp;
            <input
              disabled={!to_edit}
              onChange={(e) => changeInputArticle(e)}
              type="text"
              value={description}
              name="description"
              className="form-control"
            />
          </div>
          &nbsp;
          <div
            onClick={() => {
              to_edit
                ? actions.createArticle()
                : dispatchArticleForm({
                  type: types.CHANGE_INPUT_ARTICLE,
                  payload: { name: "to_edit", value: !to_edit },
                });
            }}
            className="flex btn-default"
          >
            <FontAwesomeIcon
              className="margin-auto"
              icon={id ? faPenToSquare : faPlus}
            />
            &nbsp;
            <span> {id ? (to_edit ? "Guardar" : "Editar") : "Crear"} </span>
          </div>
        </div>
      </section>
      {id && (
        <Tabs default={true} defaultIndex={2} >
          <TabList>
            <Tab>
              {" "}
              <FontAwesomeIcon icon={faWeightScale} />
              &nbsp;Tipo de medida
            </Tab>
            <Tab>Inventarios</Tab>
            <Tab>Movimientos</Tab>
            <Tab>Ficha técnica ({documents.elements.length})</Tab>
            <Tab>Observaciones</Tab>
          </TabList>

          <TabPanel>
            <Measure />
          </TabPanel>
          <TabPanel>
            <Inventory />
          </TabPanel>
          <TabPanel>
            <Movements />
          </TabPanel>
          <TabPanel>
            <DataSheet />
          </TabPanel>
          <TabPanel>
            <Observations />
          </TabPanel>
        </Tabs>
      )}
    </section>
  );
};

export default CreateArticle;
